'use client'

import * as TooltipPrimitive from '@radix-ui/react-tooltip'
import * as React from 'react'

import { cn } from '@/lib/utils'

const TooltipProvider = TooltipPrimitive.Provider

const Tooltip = TooltipPrimitive.Root

const TooltipTrigger = TooltipPrimitive.Trigger

const TooltipContent = React.forwardRef<
  React.ElementRef<typeof TooltipPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof TooltipPrimitive.Content>
>(({ className, sideOffset = 4, style, ...props }, ref) => {
  const isSidebarTooltip = className?.includes('sidebar-tooltip');
  const [isDark, setIsDark] = React.useState(true);
  
  React.useEffect(() => {
    const checkTheme = () => {
      const isDarkTheme = document.documentElement.classList.contains('dark') || 
                         !document.documentElement.classList.contains('light');
      setIsDark(isDarkTheme);
    };
    
    checkTheme();
    const observer = new MutationObserver(checkTheme);
    observer.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
    
    return () => observer.disconnect();
  }, []);
  
  return (
    <TooltipPrimitive.Portal>
      <TooltipPrimitive.Content
        ref={ref}
        sideOffset={sideOffset}
        className={cn(
          'z-50 overflow-hidden rounded-lg px-3 py-1.5 text-sm animate-slide-in data-[state=closed]:animate-slide-out data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2',
          !isSidebarTooltip && 'bg-primary text-primary-foreground',
          className,
        )}
        style={{
          ...(isSidebarTooltip && {
            backgroundColor: isDark ? '#19191f' : '#374151',
            opacity: 1,
            border: `1px solid ${isDark ? '#1d1c20' : '#4b5563'}`,
            color: 'white',
            backdropFilter: 'none',
          }),
          ...style,
        }}
        {...props}
      />
    </TooltipPrimitive.Portal>
  );
})
TooltipContent.displayName = TooltipPrimitive.Content.displayName

export { Tooltip, TooltipTrigger, TooltipContent, TooltipProvider }
